import React from "react";
import { openApp } from "../../helpers";

const SpinningLoader = () => {
  return (
    <div className="flex flex-col items-center justify-center space-y-6">
      <div className="relative">
        <svg
          className="animate-spin h-16 w-16 text-[#ef354c]"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
        {/* Inner rotating circle for extra visual appeal */}
        <svg
          className="absolute inset-0 animate-spin h-16 w-16 text-[#ef354c] opacity-60"
          style={{ animationDuration: "1.5s", animationDirection: "reverse" }}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12"
            cy="12"
            r="6"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeDasharray="12 6"
            fill="none"
          />
        </svg>
      </div>
      <div className="text-center">
        <p className="text-2xl font-bold text-gray-800 mb-2">
          Downloading app...
        </p>
        <p className="text-sm text-gray-500 animate-pulse">
          Please wait while we prepare your download
        </p>
      </div>
    </div>
  );
};

const Download = () => {
  React.useEffect(() => {
    openApp();
  }, []);
  return (
    <>
      <div className="flex justify-center items-center h-screen bg-gradient-to-br from-gray-50 to-gray-100">
        <SpinningLoader />
      </div>
    </>
  );
};
export default Download;
